import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    height: "100%",
    padding: "20px",
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: "10px",
  },
  disabled: {
    color: theme.palette.grey[600],
    background: theme.palette.grey[100],
  },
  icon: {
    maxHeight: "23px",
    marginBottom: "18px",
  },
  title: {
    position: "relative",
  },
  description: {
    flex: "1",
  },
  action: {
    position: "relative",
  },
}));
